module.exports = __webpack_public_path__ + "media/xunidianchang2.412826c3.mp4";